var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list__container" }, [
    _c("div", { staticClass: "reviews__content" }, [
      _c("div", { staticClass: "review" }, [
        _c(
          "div",
          { staticClass: "review__stars" },
          _vm._l(5, function(star) {
            return _c("img", {
              key: star,
              attrs: {
                src: _vm.mediaBaseUrl + "subscription/reviews/star.svg",
                alt: "star"
              }
            })
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "review__content" }, [
          _c("p", [
            _vm._v(
              "\n          " + _vm._s(_vm.activeReview.text) + "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "review__author" }, [
          _c("div", { staticClass: "author__content" }, [
            _c("div", { staticClass: "author__name" }, [
              _vm._v(_vm._s(_vm.activeReview.author))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "review__date" }, [
              _vm._v(_vm._s(_vm.activeReview.date))
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "controllers" }, [
      _c("div", { staticClass: "img", on: { click: _vm.prevSlide } }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "subscription/reviews/arrow-left.svg",
            alt: "arrow left"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img", on: { click: _vm.nextSlide } }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "subscription/reviews/arrow-right.svg",
            alt: "arrow right"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }